import {
    Button, Space, Badge, Avatar, Dropdown, Modal, message, Typography, Tag,
} from 'antd';
import { MoreOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
// import { find } from 'lodash';

import SeoMeta from 'Components/SeoMeta';

// import { useGetSubCropTypes } from '../../apis/sub-crop-types';
import FullSubCropTypeDrawer from '../FullSubCropTypeDrawer';
// import { sampleCropTypes } from '../../shared/constants';
import DynamicTable from '../DynamicTable';
import { useGetRequests } from '../../apis/requests';
import { useGetSubCropType } from '../../apis/sub-crop-types';

function SubCropTypeReviewsMgmt({
    onComplete, cropTypeId, cropType,
}) {
    const { data: entities, isLoading: isLoadingEntities, refetch: refetchEntities } = useGetRequests(null, null, 'subCropType', ['new', 'requested', 'assigned']);
    const [selectedEntityId, setSelectedEntityId] = useState(null);

    const { data: subCropType } = useGetSubCropType(selectedEntityId);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [createFlag, setCreateFlag] = useState(false);
    const [entry, setEntry] = useState(null);

    useEffect(() => {
        refetchEntities();
    }, [cropTypeId]);

    const openForEdit = () => {
        setCreateFlag(false);
        setIsDrawerOpen(true);
    };

    const handleOnCreate = (type) => {
        refetchEntities();
        setEntry(type);
        setIsDrawerOpen(false);
        openForEdit();
    };

    const openForCreate = () => {
        setCreateFlag(true);
        setIsDrawerOpen(true);
    };

    const selectAndOpen = (record) => {
        setCreateFlag(false);
        setSelectedEntityId(record.entityId);
    };

    useEffect(() => {
        if (subCropType) {
            setEntry(subCropType);
            setIsDrawerOpen(true);
        }
    }, [subCropType]);

    const doDeleteSubCropType = async (id) => {
        // try {
        //     await deleteLand.mutateAsync(id);
        message.success(id);
        message.success('تم الحذف');
        //     refetchEntities();
        // } catch (err) {
        //     message.error('لقد حصل خطأ ما');
        // }
    };

    const columns = [
        {
            title: 'الاسم',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Badge size="default" offset={[49, 5]}>
                        <Avatar
                            style={{ backgroundColor: '#f56a00' }}
                            size={49}
                            src={record.image}
                        />
                    </Badge>
                    <div style={{ marginRight: '15px' }}>
                        <Typography.Text onClick={() => selectAndOpen(record)}>
                            {text}
                        </Typography.Text>
                    </div>
                </div>
            ),
        },
        {
            title: 'بادئ الطلب',
            dataIndex: 'initiator',
            key: 'initiator',
        },
        {
            title: 'ملاحظات للمهندس الزراعي',
            dataIndex: 'adminRemarks',
            key: 'adminRemarks',
        },
        {
            title: 'المهندس الزراعي المسؤول',
            dataIndex: 'engineer',
            key: 'engineer',
        },
        {
            title: 'الردود',
            dataIndex: 'status',
            key: 'status',
            render: (text) => {
                let color = '';
                let label = '';
                switch (text) {
                case 'approved':
                    color = 'green';
                    label = 'مصدق عليه';
                    break;
                case 'new':
                    color = 'yellow';
                    label = 'جديد';
                    break;
                case 'requested':
                    color = 'yellow';
                    label = 'جديد';
                    break;
                case 'assigned':
                    color = 'volcano';
                    label = 'مُكَلَّف';
                    break;
                case 'underreview':
                    color = 'lightgreen';
                    label = 'قيد المراجعة';
                    break;
                case 'rejected':
                    color = 'lightgreen';
                    label = 'مرفوض';
                    break;
                default:
                    color = 'geekblue';
                    break;
                }
                return (
                    <Tag color={color} key={text}>
                        {label}
                    </Tag>
                );
            },
        },
        {
            dataIndex: 'operation',
            key: 'operation',
            render: (value, record) => (
                <Dropdown menu={{
                    items: [
                        {
                            key: '1',
                            label: 'عرض الملف',
                            onClick: () => {
                                setEntry(record);
                                openForEdit();
                            },
                        },
                        {
                            key: '2',
                            label: 'حذف',
                            onClick: () => {
                                Modal.confirm({
                                    title: 'هل أنت متأكد من الحذف؟',
                                    okText: 'نعم',
                                    okType: 'danger',
                                    cancelText: 'لا',
                                    onOk() {
                                        doDeleteSubCropType(record.id);
                                    },
                                });
                            },
                        },
                    ],
                }}
                >
                    <Button type="text" icon={<MoreOutlined />} />
                </Dropdown>
            ),
        },
    ];

    const handleClose = () => {
        setIsDrawerOpen(false);
        setSelectedEntityId(null);
    };

    return (
        <>
            <SeoMeta title="إدارة الأصناف" />
            <FullSubCropTypeDrawer
                width="calc(100%)"
                entry={entry}
                isOpen={isDrawerOpen}
                onConfirm={handleOnCreate}
                onClose={handleClose}
                cropTypeId={cropTypeId}
                onComplete={onComplete}
                createFlag={createFlag}
                cropType={cropType}
            />
            <Space
                direction="vertical"
                size="middle"
                style={{ display: 'flex' }}
            >
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <DynamicTable
                        tableType="pro"
                        searchable
                        searchKeys={['name']}
                        search={false}
                        columns={columns}
                        dataSource={entities}
                        rowKey="id"
                        loading={isLoadingEntities}
                        pagination={{
                            pageSize: 10,
                        }}
                        toolBarRender={() => [
                            <Button
                                key="button"
                                icon={<PlusOutlined />}
                                onClick={() => {
                                    // actionRef.current?.reload();
                                    openForCreate();
                                }}
                                type="primary"
                            >
                                إنشاء نبات جديد
                            </Button>,
                        ]}
                    />
                </Space>
            </Space>
        </>

    );
}

export default SubCropTypeReviewsMgmt;
